import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { WxService } from 'src/app/services/wx.service';
import { DeliveryMethodNoneDialogComponent } from '../delivery-method-none-dialog/delivery-method-none-dialog.component';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { PreventingFraudModalComponent } from '../preventing-fraud-modal/preventing-fraud-modal.component';

@Component({
  selector: 'app-order-confirm-dialog',
  templateUrl: './order-confirm-dialog.component.html',
  styleUrls: ['./order-confirm-dialog.component.scss'],
})
export class OrderConfirmDialogComponent implements OnInit {
  platform: any;
  busType: any;
  busSeatID: number = 0;
  exclusive: boolean = false;
  agree = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userApi: UserApiService,
    private orderApi: OrderApiService,
    private message: MessageService,
    private router: Router,
    private wx: WxService,
    private dialog: MatDialog,
    private porductApi: ProductApiService,
  ) {
    this.platform = this.data.platform;
    this.busType = this.data.bus_type;
    this.busSeatID = this.data.bus_seat_id;
    this.exclusive = this.data.exclusive;

    this.getPopcornBusType(this.busType.id);
  }

  username = '';
  password = '';
  affiliate: any = null;
  backup_code_one = '';
  backup_code_two = '';
  region_submit = '';

  ngOnInit(): void {
    this.getUserAffiliate();
  }

  busTypePlatform: any;
  async getPopcornBusType(id: number) {
    try {
      const r = await this.porductApi.getPopcornBusType(id);
      this.busTypePlatform = r.data;
    } catch (error) {}
  }

  async getUserAffiliate() {
    try {
      const r = await this.userApi.getUserAffiliate();
      this.affiliate = r.data;
      this.updatePaymentInfo();
    } catch (error) {
    } finally {
      if (
        this.data.bus_type?.platform_id === 67 &&
        this.data.bus_type?.group === '全家桶'
      ) {
        this.couponCode = 'bmh';
        this.onCouponCodeConfirm();
      }
      // if (
      //   this.data.bus_type?.platform_id === 84 &&
      //   this.data.bus_type?.name === '一年'
      // ) {
      //   this.couponCode = 'jiegehao';
      //   this.onCouponCodeConfirm();
      // }

      if (
        this.data.bus_type?.platform_id === 3 &&
        this.data.bus_type?.name === '一年'
      ) {
        this.couponCode = 'yt8';
        this.onCouponCodeConfirm();
      }
    }
  }

  totalPrice = 0;
  maxScore = 0;
  payScore = 0;
  updatePaymentInfo() {
    if (this.exclusive && !this.busType.allow_exclusive) {
      if (this.busSeatID <= 0) {
        this.exclusive = false;
      }
    }
    this.totalPrice = this.exclusive
      ? this.busType.exclusive_price
      : this.busType.price;

    if (this.affiliate?.wallet_balance > 0) {
      this.maxScore = this.totalPrice - this.getCouponValue();
      if (this.maxScore > this.affiliate.wallet_balance) {
        this.maxScore = this.affiliate.wallet_balance;
      }
    }
    this.maxScore = parseFloat(this.maxScore.toFixed(2));
    this.payScore = this.maxScore;
  }

  couponCode = '';
  checkCouponCode() {
    this.couponCode = this.couponCode.trim();
    if (!this.couponCode) {
      this.message.warn('请填写优惠码');
      return;
    }
    if (this.couponCode) {
      this.getCouponCode();
    } else if (this.couponCodeData) {
      this.couponCodeData = null;
      this.updatePaymentInfo();
    }
  }

  loading = false;
  couponCodeData: any = null;
  async getCouponCode() {
    if (!this.couponCode) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.orderApi.getCouponCode(
        this.couponCode,
        this.busType.id,
        this.busSeatID,
      );
      if (r.status === 1203) {
        this.message.warn('优惠码不存在', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1205) {
        this.message.warn('该优惠码已失效', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1204) {
        this.message.warn('该优惠码已过期', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1206) {
        this.message.warn('该优惠码已超出可用次数', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1207) {
        this.message.warn('该优惠码不适用于此产品', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1208) {
        this.message.warn('优惠码超出使用次数', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1209) {
        this.message.warn('该优惠码只有用户首单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1210) {
        this.message.warn('该优惠码只有产品首单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1211) {
        this.message.warn('该优惠码只有续费订单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
        this.couponCodeData = null;
      } else {
        this.couponCodeData = r.data;
        this.updatePaymentInfo();
      }
    } catch (error) {
      this.message.error('查询优惠码失败');
    } finally {
      this.loading = false;
    }
  }

  getCouponValue() {
    if (!this.couponCodeData || this.couponCodeData.value <= 0) {
      return 0;
    }
    let v = this.couponCodeData.value;
    if (this.couponCodeData.value_type === 'Ratio') {
      v =
        Math.round(this.totalPrice * (1 - this.couponCodeData.value) * 100.0) /
        100.0;
    }
    if (v > this.totalPrice) {
      v = this.totalPrice;
    }
    return v;
  }
  onCouponCodeConfirm() {
    if (this.couponCode) {
      this.getCouponCode();
    } else if (this.couponCodeData) {
      this.couponCodeData = null;
      this.updatePaymentInfo();
    }
  }

  pay() {
    if (this.loading) {
      return;
    }
    if (this.couponCode && !this.couponCodeData) {
      this.getCouponCode();
      return;
    }
    if (!this.busType) {
      return;
    }
    if (typeof this.payScore !== 'number' || isNaN(this.payScore)) {
      this.payScore = 0;
      this.message.warn('请输入有效的数字', { position: 'top' });
      return;
    } else if (this.payScore < 0) {
      this.payScore = 0;
      this.message.warn('请正确填写使用金额', { position: 'top' });
      return;
    } else if (this.payScore > this.maxScore) {
      this.payScore = this.maxScore;
      this.message.warn('超出使用金额', { position: 'top' });
      return;
    }
    this.message.clear();
    this.username = this.username.trim();
    this.password = this.password.trim();
    this.backup_code_one = this.backup_code_one.trim();
    this.backup_code_two = this.backup_code_two.trim();
    this.region_submit = this.region_submit.trim();

    if (this.busType.username_submit === 'Required' && !this.username) {
      this.message.warn('请填写您的邮箱', { position: 'top' });
      return;
    } else if (this.busType.password_submit === 'Required' && !this.password) {
      this.message.warn('请填写您的密码', { position: 'top' });
      return;
    } else if (
      this.busType.backup_code_one === 'Required' &&
      !this.backup_code_one
    ) {
      this.message.warn('请填写您的备用安全码1', { position: 'top' });
      return;
    } else if (
      this.busType.backup_code_two === 'Required' &&
      !this.backup_code_two
    ) {
      this.message.warn('请填写您的备用安全码2', { position: 'top' });
      return;
    } else if (!this.agree) {
      this.message.warn('请先同意隐私协议和用户协议', { position: 'top' });
      return;
    } else if (
      this.busType.region_submit === 'Required' &&
      !this.region_submit
    ) {
      this.message.warn('请填写地区', { position: 'top' });
      return;
    }
    if (this.data.platform.name === 'Apple礼品卡') {
      this.dialog
        .open(PreventingFraudModalComponent, {
          panelClass: 'tip-dialog',
        })
        .afterClosed()
        .subscribe((r) => {
          if (r) {
            this.createUserOrder(
              this.payScore,
              this.username,
              this.password,
              this.backup_code_one,
              this.backup_code_two,
              this.region_submit,
            );
          }
        });
    } else
      this.createUserOrder(
        this.payScore,
        this.username,
        this.password,
        this.backup_code_one,
        this.backup_code_two,
        this.region_submit,
      );
  }

  async createUserOrder(
    payScore: number,
    username: string,
    password: string,
    backup_code_one: string,
    backup_code_two: string,
    region_submit: string,
  ) {
    try {
      this.loading = true;
      const r = await this.orderApi.createUserOrder(
        this.busType.id,
        this.exclusive,
        payScore,
        username,
        password,
        backup_code_one,
        backup_code_two,
        this.busSeatID,
        this.couponCode,
        region_submit,
      );
      if (r.status === 1203) {
        this.message.warn('优惠码不存在', { position: 'top' });
      } else if (r.status === 1205) {
        this.message.warn('该优惠码已失效', { position: 'top' });
      } else if (r.status === 1204) {
        this.message.warn('该优惠码已过期', { position: 'top' });
      } else if (r.status === 1206) {
        this.message.warn('该优惠码已超出可用次数', { position: 'top' });
      } else if (r.status === 1207) {
        this.message.warn('该优惠码不适用于此产品', { position: 'top' });
        this.couponCodeData = null;
      } else if (r.status === 1208) {
        this.message.warn('优惠码超出使用次数', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1209) {
        this.message.warn('该优惠码只有用户首单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1210) {
        this.message.warn('该优惠码只有产品首单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status == 1211) {
        this.message.warn('该优惠码只有续费订单可用', {
          position: 'top',
        });
        this.couponCodeData = null;
      } else if (r.status === 1006) {
        this.message.warn('积分有误', { position: 'top' });
      } else if (r.status === 1101) {
        this.message.warn('商品已经下架', { position: 'top' });
      } else if (r.status === 1102) {
        this.message.warn('该商品不允许包车，请返回确认', { position: 'top' });
      } else if (r.status === 1103) {
        this.message.warn('该商品不能续费', { position: 'top' });
      } else if (r.status === 1202) {
        this.message.warn('该车座不能续费', { position: 'top' });
      } else if (r.status === 1104) {
        this.message.warn('库存不足');
      } else if (r.status === 1105) {
        this.message.warn('此产品已达购买上限，还需购买请联系客服');
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
      } else {
        /* 订单创建后直接调起支付 */
        if (r.data.status === 'Unpaid') {
          await this.payUserOrder(r.data.id);
        } else {
          this.gotoTicket(r.data);
        }
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }

  gotoTicket(data: any) {
    if (data?.bus_type_snapshot?.delivery_method === 'None') {
      this.dialog
        .open(DeliveryMethodNoneDialogComponent)
        .afterClosed()
        .subscribe((r) => {
          this.router.navigate(['/buy'], {});
        });
    } else {
      if (this.router.url === '/user/profile/seats') {
        this.message.open('支付成功');
        window.location.reload();
      } else {
        this.router.navigate(['/user/profile/seats'], {});
      }
    }
  }

  async payUserOrder(id: string) {
    try {
      /* 唯一支付方式: Waffo 电子钱包(EWALLET) */
      const r = await this.orderApi.payUserOrder(
        id,
        'Waffo',
        this.wx.isInWechat(),
        'EWALLET',
        '',
      );
      if (r.status !== 0) {
        this.message.warn('未知错误');
        return;
      }
      /* Waffo 返回 { web_url, qr, order_status }，直接用链接唤起收银台 */
      const data = r.data || {};
      if (data.web_url) {
        window.location.href = data.web_url;
      } else {
        this.message.warn('未获取到支付链接，请稍后重试');
      }
    } catch (error) {
      this.message.error('支付失败');
    }
  }

  openLink() {
    window.open('https://universalbus.cn/helping/detail/2/p/0/article/230');
  }

  @ViewChildren('conditionText') conditionTexts!: QueryList<ElementRef>;

  triggerFlashAll() {
    this.conditionTexts.forEach((el) => {
      const nativeEl = el.nativeElement;
      nativeEl.classList.add('flash-color');
      setTimeout(() => {
        nativeEl.classList.remove('flash-color');
      }, 600);
    });
  }

  goto(url: string) {
    window.open(url);
  }
}
